/* eslint-disable react-hooks/exhaustive-deps */
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { prepareHeaders } from "../user/user.api";
import { PaginationResults, TypeQuery, IUser } from "../user/user.type";
import { ApiBaseUrl } from "../../http";
import { QueryUrl, useLocationState } from '../../Utils';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { IParrainage, ParrainageFormdata } from './parrainage.type';

const ParrainageApi = createApi({
    reducerPath: "parrainageApi",
    tagTypes: ["parrainage",'parraineurs','parrainageByUser'],
    baseQuery: fetchBaseQuery({
        baseUrl: `${ApiBaseUrl}/api/`,
        prepareHeaders,
    }),
    endpoints: (build) => ({
        AddOrUpdateParrainage: build.mutation<
            IParrainage,
            { slug?: string; data: IParrainage | FormData | Partial<IParrainage> }
        >({
            query: ({ slug, data }) => ({
                url: slug ? `users/${slug}/` : `users/`,
                method: slug ? "PUT" : "POST",
                body: data,
            }),
            invalidatesTags: ["parrainage"],
        }),
        getParraineurs: build.query<PaginationResults<IUser>, TypeQuery>({
            query: (query) => QueryUrl("parraineurs", query),
            providesTags: ["parraineurs"],
        }),
        getParrainage: build.query<IUser, string>({
            query: (slug) => `parraineurs/${slug}`,
            providesTags: ["parraineurs"],
        }),
        deleteParrainage: build.mutation<ParrainageFormdata, string>({
            query: (slug) => ({
                url: `users/${slug}/`,
                method: "DELETE",
            }),
            invalidatesTags: ["parrainage"],
        }),
        listeParrainageByUser: build.query<PaginationResults<IUser>, string>({
            query: (slug) => `user/${slug}/parrainages/`,
            providesTags: ["parrainageByUser"],
        }),
    }),
});

export default ParrainageApi

export const {
    useAddOrUpdateParrainageMutation,
    useGetParraineursQuery,
    useDeleteParrainageMutation,
    useLazyGetParrainageQuery,
    useLazyListeParrainageByUserQuery
} = ParrainageApi;

export function useParrainageFromLocation(): [
    IUser,
    boolean,
    string,
    (id: string) => any
] {
    const itemState = useLocationState<IUser | undefined>(undefined);
    const [item, setItem] = useState(itemState);
    const { slug } = useParams<{ slug: string }>();
    const [findById, { data, isError, isLoading }] = useLazyGetParrainageQuery();
    const navigate = useNavigate();

    useEffect(() => {
        if (slug) {
            findById(slug);
        }
    }, [slug]);
    useEffect(() => {
        if (isError && !itemState) {
            navigate(-1);
        }
    }, [isError]);
    useEffect(() => {
        if (data) {
            
            setItem(data);
        }
    }, [data]);

    return [item as IUser, isLoading, slug as string, findById];
}


export function useParrainagesByUser(slug:any): [
    any,
    boolean,
    string,
    (slug: string) => any
] {
    const itemState = useLocationState<IUser | undefined>(undefined);
    const [parrainages, setParrainages] = useState<any>();
    const [findBySlug, { data, isError, isLoading }] = useLazyListeParrainageByUserQuery();
    const navigate = useNavigate();

    useEffect(() => {
        if (slug) {
            findBySlug(slug);
        }
    }, [slug]);
    useEffect(() => {
        if (isError && !itemState) {
            navigate(-1);
        }
    }, [isError]);
    useEffect(() => {
        if (data) {
            setParrainages(data);
        }
    }, [data]);

    return [parrainages as any, isLoading, slug as string, findBySlug];
}